import { render, staticRenderFns } from "./HomeBottom.vue?vue&type=template&id=12240caf&scoped=true"
import script from "./HomeBottom.vue?vue&type=script&lang=js"
export * from "./HomeBottom.vue?vue&type=script&lang=js"
import style0 from "./HomeBottom.vue?vue&type=style&index=0&id=12240caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12240caf",
  null
  
)

export default component.exports